var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import BaseEngineApi from '~/api/base-engine';
class SubmitService extends BaseEngineApi {
    constructor() {
        super('/submission-engine');
    }
    search(offset, limit, fileName, txId, submissionFrom, submissionTo) {
        const _super = Object.create(null, {
            newRoute: { get: () => super.newRoute }
        });
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                offset,
                limit,
                tx_id: txId,
                file_name: fileName,
                submission_from: submissionFrom,
                submission_to: submissionTo,
            };
            for (const [key, val] of Object.entries(Object.assign({}, payload))) {
                if (val === undefined)
                    delete payload[key];
            }
            return _super.newRoute.call(this, '/submission-engine/submit-svc/documents/search').post(payload);
        });
    }
    fetchFileUpload(file_name) {
        const _super = Object.create(null, {
            newRoute: { get: () => super.newRoute }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.newRoute.call(this, '/submission-engine/submit-svc/file-upload-url').post({ file_name });
        });
    }
    triggerSubmission(tx_id) {
        const _super = Object.create(null, {
            newRoute: { get: () => super.newRoute }
        });
        return __awaiter(this, void 0, void 0, function* () {
            return _super.newRoute.call(this, `/submission-engine/submit-svc/trigger-submission/${tx_id}`).post({});
        });
    }
}
const SubmitServiceApi = new SubmitService();
export default SubmitServiceApi;
